import React from "react";
import { ServiceTypeEnum } from "../../../../../../common-deprecated/types/SettingsType";
import useService from "../../../hooks/services/useService";
import * as Styles from "../../../../../../common-deprecated/styles/v2/toyota/custom/services/SharedService";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";

const BannerService = (): JSX.Element | null => {
    const data = useService(ServiceTypeEnum.Banner);

    if (!data) return null;
    const { title, description, bannerLinkImage, bannerLinkLabel, bannerLinkUrl } = data;

    return (
        <Styles.ServiceWrapper>
            {bannerLinkImage && (
                <Styles.Banner>
                    <Styles.Image src={`${bannerLinkImage}`} height={170} />
                </Styles.Banner>
            )}

            {title && <Styles.Title>{title}</Styles.Title>}

            {description && <Styles.Description dangerouslySetInnerHTML={{ __html: description }} />}

            {bannerLinkLabel && bannerLinkUrl && (
                <Button.Secondary dark as="a" href={bannerLinkUrl}>
                    {bannerLinkLabel}
                </Button.Secondary>
            )}
        </Styles.ServiceWrapper>
    );
};

export default BannerService;
